import { Injectable } from '@angular/core';

declare function addLeadingZero(value: number): number;

@Injectable({
    providedIn: 'root'
})
export class BurialsService {

    parseBurialByID(burialID: number, burialArray: any): any {
        for (var burialIndex in burialArray) {
            if (burialID == burialArray[burialIndex].fid) {
                return burialArray[burialIndex];
            }
        }
        return null;
    }

    parseApplicationByID(applicationID?: number | string, applicationArray?: any): any {
        if (!applicationID || !applicationArray) { return null; }
        for (var applicationIndex in applicationArray) {
            if (applicationArray[applicationIndex] && 
                applicationArray[applicationIndex].burialData && 
                applicationID == applicationArray[applicationIndex].burialData.qrstring) {
                return applicationArray[applicationIndex];
            }
        }
        return null;
    }

    writeValueInBurialArray(burialID: number, burialArray: any, key: string, value: any): any {
        for (var burialIndex in burialArray) {
            if (burialID == burialArray[burialIndex].fid) {
                burialArray[burialIndex][key] = value;
                break;
            }
        }
        return burialArray;
    }

    writeDokumentInApplicationArray(burialID: number, burialArray: any, key: string, value: any): any {
        for (var burialIndex in burialArray) {
            if (burialID == burialArray[burialIndex].burialData.qrstring) {
                if (!burialArray[burialIndex].burialDocs) {
                    burialArray[burialIndex].burialDocs = {};
                }
                burialArray[burialIndex].burialDocs[key] = value;
                break;
            }
        }
        return burialArray;
    }

    readableDeathTypeByID(deathTypeID: string): string {
        if (!deathTypeID || deathTypeID.length < 1) {
            return '';
        }
        switch (deathTypeID) {
            case '0':
                return 'undefiniert';
                break;
            case '1':
                return 'natürlich';
                break;
            case '2':
                return 'unnatürlich';
                break;
            case '3':
                return 'ungeklärt';
                break;
            default:
                return '';
        }
    }

    readableGenderByID(genderID: string): string {
        if (!genderID || genderID.length < 1) {
            return '';
        }
        switch (genderID) {
            case '1':
                return 'männlich';
                break;
            case '2':
                return 'weiblich';
                break;
            default:
                return '';
        }
    }

    readableDateFromString(dateString: string): string {
        if (!dateString || dateString.length < 1) {
            return '';
        }
        var dateArray = dateString.split(/[- :]/);
        if (dateArray.length < 3) {
            return '';
        }
        return dateArray[2] + '.' + dateArray[1] + '.' + dateArray[0];
    }

    readableTimeFromString(timeString: string): string {
        if (!timeString || timeString.length < 1) {
            return '';
        }
        var timeArray = timeString.split(/[- :]/);
        if (timeArray.length < 5) {
            return '';
        }
        return timeArray[3] + ':' + timeArray[4];
    }

    addLeadingZero(value: number): number {
        return addLeadingZero(value);
    }

    burialDateFromDeathDate(deathDate: string, deathTime: string): any {
        if (!deathDate || !deathTime) {
            return '';
        }
        var dateArray = deathDate.split('.');
        var timeArray = deathTime.split(':');
        if (dateArray.length != 3 || timeArray.length != 2) {
            return '';
        }
        dateArray[1] = String(Number(dateArray[1]) - 1);
        var dateTimeObject = new Date(Number(dateArray[2]), Number(dateArray[1]), Number(dateArray[0]), Number(timeArray[0]), Number(timeArray[1]));
        dateTimeObject.setHours(dateTimeObject.getHours() + 48);
        return {
            burialDate: '' + this.addLeadingZero(dateTimeObject.getDate()) + '.' + this.addLeadingZero(dateTimeObject.getMonth() + 1) + '.' + dateTimeObject.getFullYear(),
            burialTime: '' + this.addLeadingZero(dateTimeObject.getHours()) + ':' + this.addLeadingZero(dateTimeObject.getMinutes())
        };
    }

    boolFromInt(boolInt: number): boolean {
        if (!boolInt) {
            return false;
        } else if (boolInt == 1) {
            return true;
        } else {
            return false;
        }
    }

    readableUrnDeliveryTypeByID(deliveryTypeID: string): string {
        if (!deliveryTypeID || deliveryTypeID.length < 1) {
            return '';
        }
        switch (deliveryTypeID) {
            case '1':
                return 'Urnenversand';
                break;
            case '2':
                return 'Urnenabholung';
                break;
            case '3':
                return 'Urnenrückführung';
                break;
            case '4':
                return 'Urnenaufbewahrung';
                break;
            case '5':
                return 'Urnenversand International';
                break;
            case '6':
                return 'Urnenversand Europa';
                break;
            default:
                return '';
        }
    }

    readableUrnTypeByID(urnTypeID: string): string {
        if (!urnTypeID || urnTypeID.length < 1) {
            return '';
        }
        switch (urnTypeID) {
            case '17':
                return 'Friedwaldurne';
            case '18':
                return 'Aschebeutel';
            case '19':
                return 'Bio Urne';
            case '20':
                return 'Stahlkapsel';
            case '21':
                return 'Kohleurne mit Schnur';
            case '22':
                return 'Kohleurne ohne Schnur';
            case '23':
                return 'Guttenberg Urne';
            case '24':
                return 'Eigene Urne';
            default:
                return '';
        }
    }

    readableAnonymousBurialSiteByID(anonymousBurialSiteID: string): string {
        if (!anonymousBurialSiteID || anonymousBurialSiteID.length < 1) {
            return '';
        }
        switch (anonymousBurialSiteID) {
            case '15':
                return 'Rasenfriedhof';
                break;
            case '48':
                return 'Blumengarten';
                break;
            case '8':
                return 'Reinhöhenruhewald';
                break;
            case '46':
                return 'Unser Hafen';
                break;
            case '49':
                return 'Raum der Stille';
                break;
            default:
                return '';
        }
    }

    readableAnonymousBurialContractByID(anonymousBurialContractID: string): string {
        if (!anonymousBurialContractID || anonymousBurialContractID.length < 1) {
            return '';
        }
        switch (anonymousBurialContractID) {
            case '7':
                return 'Anonym';
                break;
            case '5':
                return 'Partner';
                break;
            case '6':
                return 'Baum';
                break;
            case '42':
                return 'Anonym';
                break;
            case '37':
                return 'Partner';
                break;
            case '9':
                return 'Einzelbaum, 20 Jahre';
                break;
            case '10':
                return 'Einzelbaum, 50 Jahre';
                break;
            case '11':
                return 'Familienbaum, 20 Jahre';
                break;
            case '12':
                return 'Familienbaum, 50 Jahre';
                break;
            case '13':
                return 'Gemeinschaftsbaum, 20 Jahre';
                break;
            case '14':
                return 'Gemeinschaftsbaum, 50 Jahre';
                break;
            case '15':
                return 'Bestatterbaum, 20 Jahre';
                break;
            case '16':
                return 'Bestatterbaum, 50 Jahre';
                break;
            case '31':
                return 'Freundschaftsgarb';
                break;
            case '30':
                return 'Familiengrab';
                break;
            case '19':
                return 'Einstellung 1 Jahr';
                break;
            default:
                return '';
        }
    }

    readableAnonymousBurialTypeByID(anonymousBurialTypeID: string): string {
        if (!anonymousBurialTypeID || anonymousBurialTypeID.length < 1) {
            return '';
        }
        switch (anonymousBurialTypeID) {
            case '6':
                return 'Verabschiedung an der Urne';
                break;
            case '1':
                return 'Beisetzung mit Angehörigen direkt am Grab';
                break;
            case '2':
                return 'Beisetzung mit Angehörigen ohne Halle / Waldkapelle';
                break;
            case '3':
                return 'Beisetzung mit Angehörigen mit Halle / Waldkapelle';
                break;
            case '4':
                return 'Beisetzung ohne Angehörige';
                break;
            default:
                return '';
        }
    }

    readableAdoptionTypeByID(adoptionTypeID: string): string {
        if (!adoptionTypeID || adoptionTypeID.length < 1) {
            return '';
        }
        switch (adoptionTypeID) {
            case '1':
                return 'Einäscherung mit Angehörigen mit Halle';
            case '2':
                return 'Einäscherung ohne Angehörige';
            case '3':
                return 'Sargverabschiedung in der Trauerhalle';
            case '4':
                return 'Sargverabschiedung in der Trauerhalle mit anschließender Direkteinäscherung';
            case '5':
                return 'Einäscherung mit Angehörigen ohne Halle';
            case '7':
                return 'Bestatter 1 Stunde vor Einäscherung anrufen';
            case '13':
                return 'Aufbahrung (Sarg offen)';
            case '14':
                return 'Aufbahrung (Sarg geschlossen)';
            case '15':
                return 'Trauerfeier mit Urne';
            default:
                return '';
        }
    }

    readableSalutationTypeByID(salutationTypeID: string): string {
        if (!salutationTypeID || salutationTypeID.length < 1) {
            return '';
        }
        switch (salutationTypeID) {
            case '1':
                return 'Herr';
                break;
            case '2':
                return 'Frau';
                break;
            case '3':
                return 'Familie';
                break;
            case '4':
                return 'Ordnungsamt';
                break;
            default:
                return '';
        }
    }

    salutationTypeIDByReadableSalutation(salutation: string): string {
        if (!salutation || salutation.length < 1) {
            return '';
        }
        switch (salutation) {
            case 'Herr':
                return '1';
                break;
            case 'Frau':
                return '2';
                break;
            case 'Familie':
                return '3';
                break;
            case 'Ordnungsamt':
                return '4';
                break;
            default:
                return '';
        }
    }

    readableFuneralTypeByID(funeralTypeID: string): string {
        if (!funeralTypeID || funeralTypeID.length < 1) {
            return '';
        }
        switch (funeralTypeID) {
            case '1':
                return 'dem Willen der/des Verstorbenen';
                break;
            case '2':
                return 'dem Willen der/des Personensorgeberechtigten';
                break;
            case '3':
                return 'dem Willen der/des Betreuers';
                break;
            case '4':
                return 'dem Willen des Ordnungs-/Sozialamtes';
                break;
            default:
                return '';
        }
    }

    readableReturnTypeByID(returnTypeID: string): string {
        if (!returnTypeID || returnTypeID.length < 1) {
            return '';
        }
        switch (returnTypeID) {
            case '1':
                return 'Urnenversand';
                break;
            case '2':
                return 'Abholung durch den Bestatter';
                break;
            case '3':
                return 'Rückholung mit dem nächsten Fahrdienst';
                break;
            default:
                return '';
        }
    }

    readableBoolFromInt(boolInt: string): string {
        if (!boolInt || boolInt.length < 1) {
            return '';
        }
        switch (boolInt) {
            case '0':
                return 'Nein';
                break;
            case '1':
                return 'Ja';
                break;
            default:
                return '';
        }
    }

    readableBurialPlaceFromID(placeID: string): string {
        if (!placeID || placeID.length < 1) {
            return '';
        }
        switch (placeID) {
            case '15':
                return 'Rasenfriedhof in Braubach-Dachsenhausen';
                break;
            case '48':
                return 'Blumengarten';
                break;
            case '8':
                return 'Friedhof Rheinhöhen-Ruhewald Braubach';
                break;
            case '46':
                return 'Unser Hafen';
                break;
            case '1':
                return 'Friedhof in Neidenbach';
                break;
            case '2':
                return 'Waldfriedhof in Mittelreidenbach';
                break;
            case '5':
                return 'Friedhof in Zell (Mosel)';
                break;
            case '6':
                return 'Bergfriedhof an der Gnadenkirche in Essen';
                break;
            case '7':
                return 'Cadenberge';
                break;
            case '14':
                return 'Friedhof in Bornheim';
                break;
            case '21':
                return 'Friedhof in Bad Münstereifel';
                break;
            case '29':
                return 'Begräbniswald Eitorf';
                break;
            case '43':
                return 'Friedhof in Horrweiler';
                break;
            case '50':
                return 'Kräuterhochbeet';
                break;
            case '51':
                return 'Waldlichtung Rheinhöhen-Ruhewald Braubach';
                break;
            default:
                return '';
        }
    }

    prepareBurialArray(burialArray: any): any {
        for (var burialIndex in burialArray) {


            var burialObject = burialArray[burialIndex];
          
            var burialObjectStateID = burialObject.contractStateID;        

            if (burialObjectStateID == '0') {
                burialObject['htmlHeaderClass'] = 'unconfirmed';
            } else if (burialObjectStateID == '10' || burialObjectStateID == '20') {
                burialObject['htmlHeaderClass'] = 'on-hold';
            } else if (burialObjectStateID == '30' || burialObjectStateID == '40') {
                burialObject['htmlHeaderClass'] = 'confirmed';
            } else {
                burialObject['htmlHeaderClass'] = 'isWhite';
            }

            if (burialObject.hasOwnProperty('isPrepared') && burialObject.isPrepared) {
                continue;
            }

            if (!burialObject.hasOwnProperty('contractStateID')) { continue; }

            if (!burialObjectStateID) { burialObjectStateID = '0'; }


            if (!burialObject.hasOwnProperty('contractName') || !burialObject.contractName || burialObject.contractName.indexOf('Eingang') >= 0) {
                if (!burialObject.hasOwnProperty('contractName') || !burialObject.contractName) {
                    burialObject.contractName = 'Auftrag eingegangen';
                }
                burialObject.contractNameShort = 'Eingegangen';
            }

            if (burialObject.hasOwnProperty('missingdocs')) {
                for (var missingDocsIndex in burialObject.missingdocs) {
                    if (burialObject.missingdocs[missingDocsIndex] == 'dok_we_zur_fb') {
                        burialObject.i_intentdeclerationType = '2';
                    } else if (burialObject.missingdocs[missingDocsIndex] == 'dok_antrag') {
                        burialObject.i_burialorderType = '2';
                    } else if (burialObject.missingdocs[missingDocsIndex] == 'dok_amtsarzt_ls_bereits_extern_durchgefuehrt') {
                        burialObject.i_policereleaseType = '2';
                    } else if (burialObject.missingdocs[missingDocsIndex] == 'dok_freigabe_staatsanwalt') {
                        burialObject.i_lawyerreleaseType = '2';
                    } else if (burialObject.missingdocs[missingDocsIndex] == 'dok_amtsarzt_ls_durchgefuehrt') {
                        burialObject.i_corpsepassType = '2';
                    } else if (burialObject.missingdocs[missingDocsIndex] == 'dok_todesbescheinigung') {
                        burialObject.i_deathapprovalType = '2';
                    } else if (burialObject.missingdocs[missingDocsIndex] == 'dok_besch_sterbefall') {
                        burialObject.i_deathcertificateType = '2';
                    } else if (burialObject.missingdocs[missingDocsIndex] == 'dok_urnenanforderung') {
                        burialObject.i_urnrequestSuccessType = '2';
                    }
                }
            }

            if (burialObject.hasOwnProperty('d_departmentdate') && burialObject.d_departmentdate && burialObject.d_departmentdate) {
                burialObject.d_departmentdate = this.readableDateFromString(burialObject.d_departmentdate) + ' ' + this.readableTimeFromString(burialObject.d_departmentdate) + ' Uhr';
            }

            burialObject.isPrepared = true;

            burialObject = this.prepareSearchableStringForSelectableFieldsInBurial(burialObject);

            burialArray[burialIndex] = burialObject;
           
        }

        return burialArray;
    }

    prepareHistoryArray(historyArray: any): any {
        for (var historyArrayIndex in historyArray) {
            if (!historyArray[historyArrayIndex].hasOwnProperty('payload')) {
                continue;
            }
            for (var historyObjectKey in historyArray[historyArrayIndex].payload) {
                switch (historyObjectKey) {
                    case 'v_geschlecht':
                        historyArray[historyArrayIndex].payload[historyObjectKey].value = this.readableGenderByID(historyArray[historyArrayIndex].payload[historyObjectKey].value);
                        break;
                    case 'urnenversand_rueckfuehrung_id':
                        historyArray[historyArrayIndex].payload[historyObjectKey].value = this.readableReturnTypeByID(historyArray[historyArrayIndex].payload[historyObjectKey].value);
                        break;
                    case 'dok_we_zur_fb':
                        historyArray[historyArrayIndex].payload[historyObjectKey].value = this.readableFuneralTypeByID(historyArray[historyArrayIndex].payload[historyObjectKey].value);
                        break;
                    case 'v_unnatuerlicher_tod':
                        historyArray[historyArrayIndex].payload[historyObjectKey].value = this.readableDeathTypeByID(historyArray[historyArrayIndex].payload[historyObjectKey].value);
                        break;
                    case 'ueberurne_id':
                        historyArray[historyArrayIndex].payload[historyObjectKey].value = this.readableUrnTypeByID(historyArray[historyArrayIndex].payload[historyObjectKey].value);
                        break;
                    case 'ueberurne_vorhanden':
                        if (historyArray[historyArrayIndex].payload[historyObjectKey].value == 1) {
                            historyArray[historyArrayIndex].payload[historyObjectKey].value = 'Ja';
                        } else {
                            historyArray[historyArrayIndex].payload[historyObjectKey].value = 'Nein';
                        }
                        break;
                    case 'kommune_art':
                        historyArray[historyArrayIndex].payload[historyObjectKey].value = this.readableAnonymousBurialContractByID(historyArray[historyArrayIndex].payload[historyObjectKey].value);
                        break;
                    case 'kommune_type':
                        historyArray[historyArrayIndex].payload[historyObjectKey].value = this.readableAnonymousBurialTypeByID(historyArray[historyArrayIndex].payload[historyObjectKey].value);
                        break;
                    case 'kommune_id':
                        historyArray[historyArrayIndex].payload[historyObjectKey].value = this.readableAnonymousBurialSiteByID(historyArray[historyArrayIndex].payload[historyObjectKey].value);
                        break;
                    case 'verabschiedung_id':
                        historyArray[historyArrayIndex].payload[historyObjectKey].value = this.readableAdoptionTypeByID(historyArray[historyArrayIndex].payload[historyObjectKey].value);
                        break;
                }
            }
        }
        return historyArray;
    }

    prepareSearchableStringForSelectableFieldsInBurial(burial: any) {
        let searchableStringArray: string[] = [];

        for (const key in burial) {
            switch (key) {
                case 'v_geschlecht':
                    searchableStringArray.push(this.readableGenderByID(burial[key]));
                    break;
                case 'urnenversand_rueckfuehrung_id':
                    searchableStringArray.push(this.readableReturnTypeByID(burial[key]));
                    break;
                case 'dok_we_zur_fb':
                    searchableStringArray.push(this.readableFuneralTypeByID(burial[key]));
                    break;
                case 'v_unnatuerlicher_tod':
                    searchableStringArray.push(this.readableDeathTypeByID(burial[key]));
                    break;
                case 'ueberurne_id':
                    searchableStringArray.push(this.readableUrnTypeByID(burial[key]));
                    break;
                case 'ueberurne_vorhanden':
                    if (burial[key] == 1) { searchableStringArray.push('Überurne'); }
                    break;
                case 'kommune_art':
                    searchableStringArray.push(this.readableAnonymousBurialContractByID(burial[key]));
                    break;
                case 'kommune_type':
                    searchableStringArray.push(this.readableAnonymousBurialTypeByID(burial[key]));
                    break;
                case 'kommune_id':
                    searchableStringArray.push(this.readableAnonymousBurialSiteByID(burial[key]));
                    break;
                case 'verabschiedung_id':
                    searchableStringArray.push(this.readableAdoptionTypeByID(burial[key]));
                    break;
                case 'd_urndeliverytype':
                    searchableStringArray.push(this.readableUrnDeliveryTypeByID(burial[key]));
                    break;
            }
        }

        burial.searchableString = searchableStringArray.join('|');

        return burial;
    }

    prepareApplicationArray(applicationArray: any): any {
        if (!applicationArray.burialData) {
            applicationArray.burialData = {};
          }
      
          if (!applicationArray.burialDates) {
            applicationArray.burialDates = {};
          }
      
          if (!applicationArray.burialDocs) {
            applicationArray.burialDocs = {};
          }
        return applicationArray;
    }

}